




























































































































































































































import {Getter, Action, Mutation} from "vuex-class";
import Component from "vue-class-component";
import {
  SelectWings,
  ToggleWings,
  DatePickerWings,
  FastDateGroupWings,
  NumberWings,
} from 'wings-ui-components';
import {PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {GroupFilterParams} from "@/store/sms/statistic/types";
import {beginningOfCurrentDay,currentDate,dateFilter} from "@/utils/date-util";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    NumberWings,
    SelectWings,
    ToggleWings,
    DatePickerWings,
    FastDateGroupWings,
  }, filters: {dateFilter}
})
export default class SmsGroupFilter extends BaseFilter<GroupFilterParams> {
  @PropSync('show') is_show_primary!: boolean;
  @PropSync('showAdditional') is_show_additional!: boolean;
  @PropSync('filterClone') propFilterClone!: any;

  @Mutation('setSmsStaticGroup') setStatistic: any

  @Getter("groupBy") groupByList: any;
  @Getter("groupByOptionally") groupByOptionallyList: any;
  @Getter("messageCategories") messageCategoriesList: any;
  @Getter("messageTypes") messageTypesList: any;

  @Action("getSmsStatisticGroup") actionGetItems: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getMessageCategories") actionMessageCategories: any;
  @Action("exportSmsStatisticGroup") actionExport: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): GroupFilterParams {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDate(),
      group_by: "day",
      partner: null,
      originator: null,
      service_provider: null,
      country: null,
      operator: null,
      message_category: null,
      template_id: null,
      bulk_id: null,
      broker_account_login: undefined,
      message_type: undefined,
      message_direction: "mt",
    }
  }

  params: object = {transport: MsgTransports.SMS};
  partnersList: any = []
  originatorsList: any = []
  accountsList: any = []
  serviceProvidersList:  any = []

  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "originator" : "addresser",
    "broker_account_login" : "broker_account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    this.setStatistic(null)
    this.parseGroupBy()
    try {
      this.actionMessageCategories(this.params);
      this.actionGetMessageTypes();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction() {
    this.setStatistic(null);
    this.mergeGroupBy();
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  // Override
  async doActionExport() {
    this.mergeGroupBy();
    return await this.actionExport(this.filter);
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }

  get is_show() {
    return this.is_show_primary || this.is_show_additional
  }

  set is_show(value) {
    this.is_show_primary = value;
    this.is_show_additional = value;
  }

  @Watch('is_show_primary')
  onShowPrimaryChanged(val: boolean) {
    if (!val) {
      this.is_show_additional = false
    }
  }

  @Watch('is_show_additional')
  onShowAdditionalChanged(val: boolean) {
    if (val) {
      this.is_show_primary = true
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(newVal: GroupFilterParams) {
    this.propFilterClone = newVal;
  }
}
